// extracted by mini-css-extract-plugin
module.exports = {"creative":"styles_creative__1ivHu","tab":"styles_tab__2zRx1","header":"styles_header__uTRKF","status":"styles_status__S_qQr","title":"styles_title__32VF2"};